import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";

/**
 * Fetch the nurse financial metrics.
 * @param {{ date_from?: string, date_to?: string }} [params] optional inclusive range
 *   (yyyy-MM-dd, local calendar day). Either bound may be omitted (open-ended); omit both
 *   for all-time figures.
 */
export const fetchDashboardMetricsReducer = createAsyncThunk(
  "dashboard/fetchDashboardMetrics",
  async (params = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const query = new URLSearchParams();
      if (params?.date_from) query.append("date_from", params.date_from);
      if (params?.date_to) query.append("date_to", params.date_to);
      const qs = query.toString();
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseDashboardMetrics}${qs ? `?${qs}` : ""}`;
      const response = await axiosPrivate.get(fullUrl);

      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      } else {
        const msg = response?.data?.message || i18n.t("toast.failedToFetchDashboardMetrics");
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching dashboard metrics:", error);
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorFetchingDashboardMetrics");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
